import ContentCardDetailsTab from './ContentCardDetailsTab';

export default ContentCardDetailsTab;
